import { useParams } from "react-router-dom";

import getTranslatedText from "../../../helpers/getTranslatedText";
import translations from "../../../translations";
import "./index.css";

const BoycottTitle = () => {
  const { lang } = useParams();

  return (
    <div>
      <h1 class="title">
        {getTranslatedText(translations, "boycottTitle", lang)}
        <span class="drop"></span>
        <span class="drop"></span>
        <span class="drop"></span>
        <span class="drop"></span>
        <span class="drop"></span>
        <span class="drop"></span>
      </h1>
    </div>
  );
};

export default BoycottTitle;
